enum SeoDynamicObjectType{
  Catalog = 'catalog',
  News = 'articles',
  Stocks = 'stocks',
  Diseases = 'diseases-list',
  Pharmacies = 'pharmacies'
}

export default SeoDynamicObjectType
